

// mobile menu scripts
;(function ($) {

  "use strict";

  // https://ehsangazar.com/optimizing-javascript-event-listeners-for-performance-e28406ad406c
  function throttle (callback, limit) {
    var wait = false;
    return function () {
      if (!wait) {
        callback.apply(null, arguments);
        wait = true;
        setTimeout(function () {
          wait = false;
        }, limit);
      }
    }
  }

  // https://medium.com/@mariusc23/hide-header-on-scroll-down-show-on-scroll-up-67bbaae9a78c
  // Hide Header on on scroll down
  var lastScrollTop = 0;
  var delta = 5;
  var $header = $('#header');
  var headerHeight = $header.outerHeight();

  window.addEventListener('scroll', throttle(hasScrolled, 100));

  function hasScrolled(scrollEvent) {
      var st = window.pageYOffset;

      // Make sure they scroll more than delta
      if(Math.abs(lastScrollTop - st) <= delta)
          return;

      // on homepage
      // if ($('.page--homepage').length) {
      //   if (st > 100) {
      //     $header.removeClass('header--transparent');

      //   }
      //   else {
      //     $header.addClass('header--transparent');
      //   }
      // }

      // If they scrolled down and are past the navbar, add class .nav-up.
      // This is necessary so you never see what is "behind" the navbar.
      if (st > lastScrollTop && st > headerHeight){
          // Scroll Down
         $header.removeClass('header--down').addClass('header--up');
      } else {
          // Scroll Up
          if(st + $(window).height() < $(document).height()) {
             $header.removeClass('header--up').addClass('header--down');
          }
      }

      lastScrollTop = st;
    }

    // burger
    $('.nav__toggle').on('click', function(e){
      e.preventDefault();
      $(this).toggleClass('is-active');
      $('body').toggleClass('menu-active');
    });

    $('.nav__item').on('click', function(e) {
      $('.nav__toggle').removeClass('is-active');
      $('body').removeClass('menu-active');
    });

    var waypointResizeMenu = new Waypoint({
      element: document.getElementsByTagName('body'),
      handler: function(direction) {
        $header.addClass('header--compact');
        if (direction == 'up') {
          $header.removeClass('header--compact');
        }
      },
      offset: -300
    });

    var waypointBgMenu = new Waypoint({
      element: document.getElementsByTagName('body'),
      handler: function(direction) {
        $header.addClass('header--bg');
        if (direction == 'up') {
          $header.removeClass('header--bg');
        }
      },
      offset: -50
    });

})(jQuery);
